import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {ShareholderDTO} from '@dto/entities/shareholder-dto.model';
import {API_ENTITY_SHARE_CLASS_SHAREHOLDERS} from '../../../config/urls';
import {UrlService} from '@shared/services/url.service';

@Injectable({
  providedIn: 'root'
})
export class ShareholdersService {
  private readonly http = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  getShareHoldersForClient(clientCode: string, shareClassLineNo: number, shareClass: string, currencyCode: string): Observable<ShareholderDTO[]> {
    const endpointUrl = this.urlService.buildUrl(API_ENTITY_SHARE_CLASS_SHAREHOLDERS, clientCode, shareClass, shareClassLineNo.toString(), currencyCode);
    return this.http.get<ShareholderDTO[]>(endpointUrl);
  }

}
